export { default as olympicTestReducer } from './olympic-test-slice';
